module.exports = __webpack_public_path__ + "img/thumbnail_SussexChicken_m_leucistic.c9eb4793.png";